var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIntro)?_c('div',{staticClass:"instant-chat-intro"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.body)}}),_c('i',{staticClass:"zmdi zmdi-close",on:{"click":_vm.close}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }